export enum ECompletedReasons {
  DOES_NOT_EXIST = "Streetlight DNE",
  NON_CE = "Non-CE Streetlight",
}
